import { createFileRoute } from "@tanstack/react-router";

import { HubspotFormPage } from "~/pages/connection-new/hubspot-form.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/connections/new/_connection/hubspot",
)({
  component: HubspotFormPage,
});
